import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  margin: 0 auto 7px;\n  transition: fill ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  /* subText mixin is here because different styled-components versions on\n  different projects are causing problems with \"as\" property. This time it was\n  overriding SubText styles */\n  ", "\n\n  margin: 0;\n  opacity: ", ";\n  overflow: visible;\n  pointer-events: ", ";\n  text-align: center;\n  text-decoration: none;\n  transition: color ", ";\n\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n  }\n\n  &:focus {\n    color: ", ";\n    text-decoration: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { color, property } from '@scp/ui-shared/theme/variables';
import { Icon } from '@scp/ui-shared/theme/icons';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect/withRippleEffect';
import { subText } from '@scp/ui-shared/theme/typography-styles';
import { LinkOrButton } from './LinkOrButton';
var IconButtonWithoutProps = withRippleEffect(LinkOrButton);

var shouldForwardProp = function shouldForwardProp(prop) {
  return !['noMargin', 'secondary', 'medium'].includes(prop);
};

var IconButtonWithLabelWrapper = styled(IconButtonWithoutProps).withConfig({
  shouldForwardProp: shouldForwardProp
}).attrs({
  noMargin: true,
  secondary: true,
  medium: true
})(_templateObject(), subText, function (props) {
  return props.disabled ? 0.4 : 1;
}, function (props) {
  return props.disabled ? 'none' : 'auto';
}, property.transition, color.textPrimary, color.textSecondary);
var IconButtonIcon = styled(Icon).attrs({
  color: 'currentColor'
})(_templateObject2(), property.transition);
export var IconButtonWithLabel = function IconButtonWithLabel(_a) {
  var children = _a.children,
      label = _a.label,
      iconName = _a.iconName,
      otherProps = __rest(_a, ["children", "label", "iconName"]);

  return React.createElement(IconButtonWithLabelWrapper, Object.assign({}, otherProps), React.createElement(IconButtonIcon, {
    name: iconName
  }), label);
};